import React, { useState, useEffect } from "react";
import { Box, Stack, Typography } from "@mui/material";
import moment from "moment";
import "./PujaEndTimer.scss";
import { LOCALIZATION } from "../../utils/localization";
import { useTranslation } from "react-i18next";

interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

interface PujaEndTimerProps {
  endDate: any;
}

const PujaEndTimer: React.FC<PujaEndTimerProps> = ({ endDate }) => {
  const { t, i18n } = useTranslation();
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [isInvalidDate, setIsInvalidDate] = useState<boolean>(false);

  useEffect(() => {
    if (!endDate || !moment(endDate).isValid()) {
      setIsInvalidDate(true);
      return;
    } // Exit if endDate is invalid
    setIsInvalidDate(false);
    const timerId = setInterval(() => {
      const now = moment();
      const endDateNormalised = new Date(endDate);
      endDateNormalised.setHours(23);
      endDateNormalised.setMinutes(59);
      endDateNormalised.setSeconds(59);
      const timeDifference = moment(endDateNormalised).diff(now);
      if (timeDifference <= 0) {
        clearInterval(timerId);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      } else {
        const duration = moment.duration(timeDifference);
        setTimeLeft({
          days: Math.floor(duration.asDays()),
          hours: duration.hours(),
          minutes: duration.minutes(),
          seconds: duration.seconds(),
        });
      }
    }, 1000);

    return () => clearInterval(timerId);
  }, [endDate]);

  if (
    isInvalidDate ||
    (timeLeft.days === 0 &&
      timeLeft.hours === 0 &&
      timeLeft.minutes === 0 &&
      timeLeft.seconds === 0)
  ) {
    return null;
  }

  return (
    <Box className="pujaBookingCloseSec">
      <Typography className="bookingCloseTitle">
        {t(LOCALIZATION.Puja_Booking_Closes_In)}
      </Typography>
      <Stack className="bookingCloseTimer" direction="row" alignItems="center">
        {timeLeft.days !== 0 && (
          <>
            <Typography>{timeLeft.days} Days</Typography>
            <Typography variant="h6" className="colonDivider">:</Typography>
          </>
        )}
        {timeLeft.hours !== 0 && (
          <>
            <Typography>{timeLeft.hours} Hours</Typography>
            <Typography variant="h6" className="colonDivider">:</Typography>
          </>
        )}
        {timeLeft.minutes !== 0 && (
          <>
            <Typography>{timeLeft.minutes} Mins</Typography>
            <Typography variant="h6" className="colonDivider">:</Typography>
          </>
        )}
        <Typography>{timeLeft.seconds} Secs</Typography>
      </Stack>
    </Box>
  );
};

export default PujaEndTimer;
